import { render, staticRenderFns } from "./OutlineButton.vue?vue&type=template&id=7ffb62eb&"
import script from "./OutlineButton.vue?vue&type=script&lang=js&"
export * from "./OutlineButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VBtn,VHover})
